import { BUTTON_PRESS } from './baseEvents'

const GUARD_ACTIVITY = 'Guard Activity'
const GUARD_DETAIL_DRAWER = 'Guard Detail Drawer'

export const GUARD_ACTIVITY_FILTERS_APPLIED = `${GUARD_ACTIVITY} View: Filters Applied`
export const GUARD_ACTIVITY_GUARD_ROW_BUTTON_PRESS = `${BUTTON_PRESS} ${GUARD_ACTIVITY} - Guard Row`
export const GUARD_DETAIL_DRAWER_CLOSE_BUTTON_PRESS = `${BUTTON_PRESS} ${GUARD_DETAIL_DRAWER} - Close`
export const GUARD_DETAIL_DRAWER_FEED_FILTER_BUTTON_PRESS = `${BUTTON_PRESS} ${GUARD_DETAIL_DRAWER} - Feed Filter`
export const GUARD_DETAIL_DRAWER_INCIDENT_ROW_BUTTON_PRESS = `${BUTTON_PRESS} ${GUARD_DETAIL_DRAWER} - Incident Row`
export const GUARD_DETAIL_DRAWER_TOUR_ROW_BUTTON_PRESS = `${BUTTON_PRESS} ${GUARD_DETAIL_DRAWER} - Tour Row`
// The epic's exact string — "Guard Report", not "Guard Activity". The facility
// export fires the same event with `report_type: 'facility'`.
export const GUARD_REPORT_DOWNLOAD_PDF_BUTTON_PRESS = `${BUTTON_PRESS} Guard Report - Download PDF`
